import { render, staticRenderFns } from "./QrTypeCard.vue?vue&type=template&id=992fe594&scoped=true"
import script from "./QrTypeCard.vue?vue&type=script&lang=js"
export * from "./QrTypeCard.vue?vue&type=script&lang=js"
import style0 from "./QrTypeCard.vue?vue&type=style&index=0&id=992fe594&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992fe594",
  null
  
)

export default component.exports